'use strict';

window.onload = function(){

let options = {

    enableHighAccuracy:true,
    timeout : 1000,
    max : 32000
};

if(navigator.geolocation){
    navigator.geolocation.watchPosition(displayPosition, options);
}
else{
    displayError("Geolocation Not Available");
}

};